import { createSelector } from '@ngrx/store';

import { templateFeature } from './template.feature';

const { selectTemplateState } = templateFeature;

export const selectTemplates = createSelector(
  selectTemplateState,
  ({ templates }) => templates,
);

export const selectTemplatesCachedAt = createSelector(
  selectTemplateState,
  ({ templatesCachedAt }) => templatesCachedAt,
);

export const selectLoadTemplatesError = createSelector(
  selectTemplateState,
  ({ loadTemplatesError }) => loadTemplatesError,
);

export const selectFolderCreationError = createSelector(
  selectTemplateState,
  ({ folderCreationError }) => folderCreationError,
);

export const selectCreatedFolderId = createSelector(
  selectTemplateState,
  ({ createdFolderId }) => createdFolderId,
);
